<template>
<div class="pc-row">
  <pc-col :col="col" v-for="(col, i) in pc" :key="i" />
</div>
</template>

<script>
import { mapState } from 'vuex'
import PcCol from '../components/PcCol.vue'

export default {
  name: 'PcArea',
  components: {
    'pc-col': PcCol
  },
  data: () => ({

  }),
  computed: {
    ...mapState([
      'pc'
    ])
  },
  created() {
    this.$store.dispatch('fetchPC');
  }
}
</script>

<style>
.pc-row {
  display: flex;
  flex-direction: row;
}
</style>
